import React, { useEffect } from 'react';
import i18next from 'i18next';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import * as storage from '@storage'

const useStyles = makeStyles((theme) => ({

    pending: {
        backgroundColor: '#3a8bd8'
    },
    approved: {
        backgroundColor: '#3ba96a'
    },
    refused: {
        backgroundColor: '#ff7663'
    },
    ul: {
        '& li': {
            display: 'inline-block',
            margin: '0.5px'
        },
        '& li:last-of-type': {
            borderColor: '#7d7d7d !important',
        }
    },
    divColors: {
        color:'white',
        padding: '0px 15px',
        border: '1px solid #bfbfbf',
        borderRadius: '5px',
        fontSize: '10px'
    }
}));

function LegendTypeDay(props) {
    const classes = useStyles();

    useEffect(() => {

    }, []);

    return (
        <>
            <ul className={classes.ul}>
                <li>
                    <div className={`${classes.divColors} ${classes.pending}`}>{i18next.t('approvalCentral:status.pending')}</div>
                </li>
                <li>
                    <div className={`${classes.divColors} ${classes.approved}`}> {i18next.t('approvalCentral:status.approved')}</div>
                </li>
                <li>
                    <div className={`${classes.divColors} ${classes.refused}`}> {i18next.t('approvalCentral:status.refused')}</div>
                </li>
            </ul>
        </>
    );
}

export default withNamespaces(['approvalCentral', 'buttons'], { wait: true })(LegendTypeDay);